module.exports = __webpack_public_path__ + "img/3.a9b8c241.jpg";